import { Link } from "react-router";
import { Button } from "@/components/ui/button";
import { PlusIcon } from "@heroicons/react/16/solid";

import { ServiceList } from "@/features/clinician/services/components/service-list";

const Services = () => {
    return (
        <>
            <div className="px-4 py-8">
                <div className="container mx-auto">
                    <div className="mb-4 flex">
                        <h1 className="mb-4 text-2xl font-semibold">
                            Your services
                        </h1>

                        <Button variant="primary" className="ml-auto" asChild>
                            <Link to="/clinician/services/new">
                                <PlusIcon className="stroke-2" />
                                Add Service
                            </Link>
                        </Button>
                    </div>
                    <ServiceList />
                </div>
            </div>
        </>
    );
};

export default Services;
